module.exports = __webpack_public_path__ + "static/media/close-thin.cc89712b.svg";